import React from 'react';

export default function SettingsSection({ title, children, footer }) {
  return (
    <section style={styles.wrapper}>
      {title && <h2 style={styles.title}>{title}</h2>}
      <div style={styles.card}>{children}</div>
      {footer && <p style={styles.footer}>{footer}</p>}
    </section>
  );
}

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  title: {
    margin: '0 4px',
    fontSize: 12,
    fontWeight: 700,
    color: '#6B6B6B',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  card: {
    background: '#FFFFFF',
    borderRadius: 16,
    overflow: 'hidden',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
  },
  footer: {
    margin: '4px 4px 0',
    fontSize: 11,
    color: '#9A9A9A',
  },
};
